export const EQUIPMENT = [
  {
    key: 'dry_van',
    name: 'Dry Van',
    id: 3,
    trailer_equipment_types: [
      { name: "53' Van", key: '53_van', id: 12, parent_id: 3 },
      { name: "48' Van", key: '48_van', id: 13, parent_id: 3 },
      { name: "40' Van", key: '40_van', id: 14, parent_id: 3 },
      { name: "20' Van", key: '20_van', id: 15, parent_id: 3 },
      { name: 'Vented Van', key: 'vented_van', id: 16, parent_id: 3 },
      { name: 'Plate Trailer', key: 'plate_trailer', id: 17, parent_id: 3 },
    ],
  },
  {
    key: 'reefer',
    name: 'Reefer',
    id: 2,
    trailer_equipment_types: [
      { name: "53' Reefer", key: '53_reefer', id: 8, parent_id: 2 },
      { name: "48' Reefer", key: '48_reefer', id: 9, parent_id: 2 },
      { name: 'Space Saver Reefer', key: 'space_saver_reefer', id: 10, parent_id: 2 },
      { name: 'Ice Cream Trailer', key: 'ice_cream_trailer', id: 11, parent_id: 2 },
    ],
  },
  {
    key: 'open_deck',
    name: 'Flatbed',
    id: 1,
    trailer_equipment_types: [
      { name: "53' Flatbed", key: '53_flatbed', id: 4, parent_id: 1 },
      { name: "48' Flatbed", key: '48_flatbed', id: 5, parent_id: 1 },
      { name: 'Double Drop', key: 'double_drop', id: 6, parent_id: 1 },
      { name: 'Stepdeck', key: 'stepdeck', id: 7, parent_id: 1 },
    ],
  },
  {
    key: 'specialized',
    name: 'Specialized',
    id: 20,
    trailer_equipment_types: [],
  },
  {
    key: 'drop_trailer',
    name: 'Drop Trailer',
    id: 4,
    trailer_equipment_types: [],
  },
]

export const findEquipment = (parentId: number | string | undefined) => {
  return parentId
    ? EQUIPMENT.find(eq => eq.id === parseInt(String(parentId), 10)) || EQUIPMENT[0]
    : EQUIPMENT[0]
}

export const EQUIPMENT_FOR_LANES = EQUIPMENT.filter(elem =>
  ['dry_van', 'reefer', 'open_deck', 'specialized'].includes(elem.key)
).map(entry => ({
  ...entry,
  label: entry.name,
  value: entry.id,
}))

export const DEFAULT_EQUIPMENT_ID = 3

export const DEFAULT_DROP_TRAILER = {
  icon: 'drop_trailer',
  name: 'Drop Trailer',
  parent_id: 4,
}

export const ALL_EQUIPMENT_SUBTYPES = EQUIPMENT.map(equip => equip.trailer_equipment_types).flat()

export const ALL_RESULTS = 'all'

export const PREFERRED_LANES_EQUIPMENT_TYPES = [
  { name: 'Dry Van' },
  { name: 'Reefer' },
  { name: 'Flatbed' },
]
export const MARKETPLACE_EQUIPMENT_TYPES = [
  { name: 'Dry Van', key: 'dry_van', id: 3 },
  { name: 'Reefer', key: 'reefer', id: 2 },
  { name: 'Flatbed', key: 'open_deck', id: 1 },
]

export const SHIPPER_RATE_EQUIPMENT_TYPES = [
  { name: "53' Van", key: '53_van' },
  { name: "53' Reefer", key: '53_reefer' },
  { name: "53' Flatbed", key: '53_flatbed' },
  { name: "48' Flatbed", key: '48_flatbed' },
]

export const EQUIPMENT_DISPLAY = {
  ANY_EQUIPMENT: 'Any Equip',
}

export const HAUL_TYPE_MILES = {
  local: {
    min: 0,
    max: 100,
  },
  short: {
    min: 100,
    max: 300,
  },
  long: {
    min: 300,
    max: 999999,
  },
}
